module.exports = __webpack_public_path__ + "img/cancellation_curtailment_icon.586fbef1.png";